import AxiosStatic from "axios";

class BusinessIndustryService {
    $http = AxiosStatic

    list() {
        return this.$http.get("/api/BusinessIndustry/List");
    }
}

export default new BusinessIndustryService();
